import { useTranslation } from 'react-i18next'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Pagination(theme: any) {
  const { t } = useTranslation()
  return {
    MuiPagination: {
      styleOverrides: {
        ul: {
          ' li': {
            '&:first-of-type': {
              display: 'inline-flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '> button::after': {
                marginLeft: '0.625rem',
                content: `"${t('pagination.prevText')}"`,
              },
            },
            '&:last-of-type': {
              display: 'inline-flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '> button::before': {
                marginRight: '0.625rem',
                content: `"${t('pagination.nextText')}"`,
              },
            },
          },
          '@media (max-width: 770px)': {
            ' li': {
              '&:first-of-type > button::after': {
                content: '""',
              },
              '&:last-of-type > button::before': {
                content: '""',
              },
            },
          },
        },
      },
    },
    
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.light,
          },
        },
      },
    },
  }
}
